import { NOTIFICATIONTYPE } from "Store/Notification/ActionTypes";
import { ACTION_TYPE, getActionTypes } from "Store/Shared/Actions/Helpers";
import ACTIONS from "./ActionTypes";
import { ExtensionId } from "./PropTypes";

export const fetchExtensions = (): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_EXTENSIONS),
    shouldCallAPI: state => state.settings.extensions._forceFetch,
    callAPI: {
        url: '/api/settings/extensions'
    }
});

export const patchExtension = (id: ExtensionId, body: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.PATCH_EXTENSION),
    callAPI: {
        method: 'PATCH',
        url: `/api/settings/extensions/${id}`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    }
});

export const createExtension = (body: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.CREATE_EXTENSION),
    callAPI: {
        method: 'POST',
        url: `/api/settings/extensions`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    }
})
